import { useMonth as useOriginalMonth } from '@datepicker-react/hooks';
import { useTranslation } from 'next-i18next';

import { useDateFormats } from './dateFormats';

const daysByRow = 7;

const chunk = (array, size) =>
  [...new Array(Math.ceil(array.length / size))].map((_, chunkNumber) => {
    const chunk = array.slice(chunkNumber * size, chunkNumber * size + size);
    const chunkLength = chunk.length;
    const remaining = chunkLength % 7;

    return remaining === 0 ? chunk : [...chunk, ...new Array(size - remaining).fill(0)];
  });

export const useMonth = ({ year, month, firstDayOfWeek = 0, language, date }) => {
  const {
    i18n: { language: locale }
  } = useTranslation();
  const { formatDay, formatWeekDay, formatMonth } = useDateFormats(locale || language);

  const data = useOriginalMonth({
    year,
    month,
    firstDayOfWeek,
    dayLabelFormat: formatDay,
    weekdayLabelFormat: formatWeekDay,
    monthLabelFormat: formatMonth
  });

  const days = chunk(data.days, daysByRow);

  return { ...data, days, year, date };
};

export const useMonths = (activeMonths, firstDayOfWeek, language, dates = []) =>
  activeMonths.map(({ year, month }, index) => useMonth({ year, month, firstDayOfWeek, language, date: dates[index] }));
